module.exports = __webpack_public_path__ + "img/SETTING.e511d715.svg";